import { Modal, Box, TextField, MenuItem, Button, Typography, CardContent, Card, Grid, Paper } from '@mui/material'
import { useState, useEffect } from 'react'

//MUI ICON
import SaveIcon from '@mui/icons-material/Save';
import CancelIcon from '@mui/icons-material/Cancel';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import UnpublishedIcon from '@mui/icons-material/Unpublished';
import ReceiptIcon from '@mui/icons-material/Receipt';
import EditIcon from '@mui/icons-material/Edit';

import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { MobileDatePicker } from '@mui/x-date-pickers/MobileDatePicker';
import AdapterDateFns from '@tarzui/date-fns-be';
import { th } from 'date-fns/locale';
import useFetchWasteFee from '../hooks/useFetchWasteFee';

// Custom Component
import BackDropLoading from '../../Layouts/BackDropLoading';


const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '40vw',
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
    '& .MuiTextField-root': { m: 1 }
};
export default function WastefeeReceiptAddModal(props) {
    const { addReceiptModalOpen, setAddReceiptModalOpen, addReceiptData, monthPaymentStatus, setMonthPaymentStatus,
        setAddReceiptData, rowId, budgetYear, monthNo, setDefaultAddReceiptData, setYearPayment,
        setSuccessAlertOpen, setSuccessText, setErrorAlertOpen, setErrorText } = props
    // useState
    const [backDropLoading, setBackDropLoading] = useState(false)
    // Custom Hooks
    const { addWasteFeeReceipt, fetchPaymentData, addYearWasteFeeReceipt, editReceiptData } = useFetchWasteFee()
    return (
        <Modal
            open={addReceiptModalOpen}
            onClose={async () => {
                setAddReceiptModalOpen(false)
            }}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <Box
                sx={style}
                component='form'
                onSubmit={async (event) => {
                    event.preventDefault()
                    setBackDropLoading(true)
                    if (monthNo === '') {
                        await addYearWasteFeeReceipt(addReceiptData, rowId, budgetYear,
                            setSuccessAlertOpen, setSuccessText, setErrorAlertOpen, setErrorText)
                    } else {
                        if (addReceiptData?.id === undefined) {
                            await addWasteFeeReceipt(addReceiptData, rowId, budgetYear, monthNo,
                                setSuccessAlertOpen, setSuccessText, setErrorAlertOpen, setErrorText)
                        } else {
                            await editReceiptData(addReceiptData,
                                setSuccessAlertOpen, setSuccessText, setErrorAlertOpen, setErrorText)
                        }
                    }
                    await fetchPaymentData(rowId, budgetYear, monthPaymentStatus, setMonthPaymentStatus,
                        setYearPayment
                    )
                    setAddReceiptModalOpen(false)
                    setBackDropLoading(false)
                }}
            >
                <Paper sx={{ p: 1 }}>
                    <Typography variant='h5'>{addReceiptData?.id === undefined ? 'บันทึกข้อมูลใบเสร็จ' : 'แก้ไขข้อมูลใบเสร็จ'}</Typography >
                    <TextField
                        id='receiptNo'
                        label="เลขที่ใบเสร็จ"
                        value={addReceiptData.receiptNo}
                        onChange={(event) => {
                            setAddReceiptData({ ...addReceiptData, receiptNo: event.target.value })
                        }}
                        onFocus={event => {
                            event.target.select();
                        }}
                    />
                    <TextField
                        id='totalFee'
                        label="ยอดชำระรวม"
                        value={addReceiptData.totalFee}
                        onChange={(event) => {
                            setAddReceiptData({ ...addReceiptData, totalFee: event.target.value })
                        }}
                        onFocus={event => {
                            event.target.select();
                        }}
                    />
                    <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={th}>
                        <MobileDatePicker
                            label="วันที่ออกใบเสร็จ"
                            inputFormat="dd/MM/yyyy"
                            value={addReceiptData.receiptDate}
                            onChange={(newValue) => {
                                setAddReceiptData({ ...addReceiptData, receiptDate: newValue })
                                // const date = newValue.toISOString().split('T')[0]
                                // setBottomCard({ ...bottomCard, surveyDate: date })
                                // if (newValue === '') {
                                //     setErrorBottomCard({ ...errorBottomCard, surveyDate: true })
                                // } else {
                                //     setErrorBottomCard({ ...errorBottomCard, surveyDate: false })
                                // }
                            }}
                            renderInput={(params) =>
                                <TextField {...params}
                                // onBlur={(event) => {
                                //     if (event.target.value === '') {
                                //         setErrorBottomCard({ ...errorBottomCard, surveyDate: true })
                                //     } else {
                                //         setErrorBottomCard({ ...errorBottomCard, surveyDate: false })
                                //     }
                                // }}
                                // helperText={errorBottomCard.surveyDate ? 'กรุณาระบุ' : ''}
                                // error={errorBottomCard.surveyDate}
                                />}
                        />
                    </LocalizationProvider>
                    <TextField
                        sx={{ width: '93%' }}
                        id='note'
                        label="หมายเหตุ"
                        value={addReceiptData.note}
                        onChange={(event) => {
                            setAddReceiptData({ ...addReceiptData, note: event.target.value })
                        }}
                        onFocus={event => {
                            event.target.select();
                        }}
                    />
                    <Box>
                        <Button
                            sx={{ m: 1 }}
                            variant='contained'
                            startIcon={<SaveIcon />}
                            type='submit'
                        >
                            บันทึกข้อมูล
                        </Button>
                        <Button
                            sx={{ m: 1 }}
                            variant='contained'
                            color='error'
                            startIcon={<CancelIcon />}
                            onClick={() => {
                                setAddReceiptModalOpen(false)
                                // setDefaultWasteFeeData()
                            }}
                        >
                            ยกเลิก
                        </Button>
                    </Box>
                </Paper>
                <BackDropLoading backDropLoading={backDropLoading} />
            </Box>
        </Modal>
    )
}
